/* Devis normalise optique - Les Lunettes de Pauline
   Bundle genere par build-bundle.js, ne pas editer a la main.
   Genere le 2026-09-21
   Modules : bareme.data.js, devis.js, devis-pdf.js, opticien.js
   Expose window.DevisNormalise */
(function (global) {
  'use strict';

/* ===== bareme.data.js ===== */
// Table LPP classe A - decision du 6 mars 2019 (JORFTEXT000038376601).
// Genere automatiquement, ne pas editer a la main.
// [code, type, famille, plage, base, plv, regroupementA, regroupementB]
const VERRES = [["2263287", "unifocal", "spherique", "n1", 9.75, 32.5, "V01", "VU1"],
["2254911", "unifocal", "spherique", "n2", 11.25, 37.5, "V01", "VU1"],
["2201814", "unifocal", "spherique", "n3", 14.25, 47.5, "V01", "VU1"],
["2214840", "unifocal", "spherique", "n4", 14.25, 47.5, "V02", "VU4"],
["2223394", "unifocal", "spherique", "n5", 29.25, 97.5, "V02", "VU4"],
["2254727", "unifocal", "spherique", "n6", 29.25, 97.5, "V02", "VU4"],
["2229362", "unifocal", "spherique", "p1", 9.75, 32.5, "V01", "VU1"],
["2238444", "unifocal", "spherique", "p2", 11.25, 37.5, "V01", "VU1"],
["2238823", "unifocal", "spherique", "p3", 14.25, 47.5, "V01", "VU1"],
["2260509", "unifocal", "spherique", "p4", 14.25, 47.5, "V02", "VU4"],
["2274380", "unifocal", "spherique", "p5", 29.25, 97.5, "V02", "VU4"],
["2203316", "unifocal", "spherique", "p6", 29.25, 97.5, "V02", "VU4"],
["2234050", "unifocal", "cyl 0,25-4,00", "n1", 11.25, 37.5, "V01", "VU2"],
["2231235", "unifocal", "cyl 0,25-4,00", "n2", 12.75, 42.5, "V01", "VU2"],
["2217525", "unifocal", "cyl 0,25-4,00", "n3", 15.75, 52.5, "V01", "VU2"],
["2241392", "unifocal", "cyl 0,25-4,00", "n4", 15.75, 52.5, "V02", "VU6"],
["2277266", "unifocal", "cyl 0,25-4,00", "n5", 30.75, 102.5, "V02", "VU6"],
["2220384", "unifocal", "cyl 0,25-4,00", "n6", 30.75, 102.5, "V02", "VU6"],
["2218559", "unifocal", "cyl 0,25-4,00", "s1", 11.25, 37.5, "V01", "VU3"],
["2254584", "unifocal", "cyl 0,25-4,00", "s2", 12.75, 42.5, "V01", "VU3"],
["2258406", "unifocal", "cyl 0,25-4,00", "s3", 15.75, 52.5, "V01", "VU3"],
["2203871", "unifocal", "cyl 0,25-4,00", "s4", 15.75, 52.5, "V02", "VU7"],
["2231258", "unifocal", "cyl 0,25-4,00", "s5", 30.75, 102.5, "V02", "VU7"],
["2215905", "unifocal", "cyl 0,25-4,00", "s6", 30.75, 102.5, "V02", "VU7"],
["2255520", "unifocal", "cyl > 4,00", "n1", 15.75, 52.5, "V02", "VU5"],
["2284071", "unifocal", "cyl > 4,00", "n2", 17.25, 57.5, "V02", "VU5"],
["2266080", "unifocal", "cyl > 4,00", "n3", 20.25, 67.5, "V02", "VU5"],
["2238409", "unifocal", "cyl > 4,00", "n4", 20.25, 67.5, "V02", "VU6"],
["2293390", "unifocal", "cyl > 4,00", "n5", 35.25, 117.5, "V02", "VU6"],
["2236586", "unifocal", "cyl > 4,00", "n6", 35.25, 117.5, "V02", "VU6"],
["2245190", "multifocal", "spherique", "n1", 13.5, 45.0, "V03", "VM1"],
["2235977", "multifocal", "spherique", "n2", 15.0, 50.0, "V03", "VM1"],
["2232648", "multifocal", "spherique", "n3", 18.0, 60.0, "V04", "VM4"],
["2234357", "multifocal", "spherique", "n4", 18.0, 60.0, "V04", "VM4"],
["2217229", "multifocal", "spherique", "n5", 18.0, 60.0, "V04", "VM4"],
["2272398", "multifocal", "spherique", "n6", 30.0, 100.0, "V04", "VM4"],
["2267240", "multifocal", "spherique", "p1", 13.5, 45.0, "V03", "VM1"],
["2264884", "multifocal", "spherique", "p2", 15.0, 50.0, "V03", "VM1"],
["2241009", "multifocal", "spherique", "p3", 18.0, 60.0, "V04", "VM4"],
["2209193", "multifocal", "spherique", "p4", 18.0, 60.0, "V04", "VM4"],
["2253248", "multifocal", "spherique", "p5", 18.0, 60.0, "V04", "VM4"],
["2237829", "multifocal", "spherique", "p6", 30.0, 100.0, "V04", "VM4"],
["2216885", "multifocal", "cyl 0,25-4,00", "n1", 18.0, 60.0, "V03", "VM2"],
["2245875", "multifocal", "cyl 0,25-4,00", "n2", 19.5, 65.0, "V03", "VM2"],
["2223626", "multifocal", "cyl 0,25-4,00", "n3", 22.5, 75.0, "V03", "VM2"],
["2201754", "multifocal", "cyl 0,25-4,00", "n4", 22.5, 75.0, "V03", "VM2"],
["2261087", "multifocal", "cyl 0,25-4,00", "n5", 22.5, 75.0, "V04", "VM6"],
["2247093", "multifocal", "cyl 0,25-4,00", "n6", 34.5, 115.0, "V04", "VM6"],
["2234475", "multifocal", "cyl 0,25-4,00", "s1", 18.0, 60.0, "V03", "VM3"],
["2225648", "multifocal", "cyl 0,25-4,00", "s2", 19.5, 65.0, "V03", "VM3"],
["2228931", "multifocal", "cyl 0,25-4,00", "s3", 22.5, 75.0, "V03", "VM3"],
["2287514", "multifocal", "cyl 0,25-4,00", "s4", 22.5, 75.0, "V03", "VM3"],
["2275847", "multifocal", "cyl 0,25-4,00", "s5", 22.5, 75.0, "V04", "VM7"],
["2237775", "multifocal", "cyl 0,25-4,00", "s6", 34.5, 115.0, "V04", "VM7"],
["2288293", "multifocal", "cyl > 4,00", "n1", 22.5, 75.0, "V03", "VM5"],
["2204563", "multifocal", "cyl > 4,00", "n2", 24.0, 80.0, "V03", "VM5"],
["2292544", "multifocal", "cyl > 4,00", "n3", 27.0, 90.0, "V03", "VM5"],
["2234245", "multifocal", "cyl > 4,00", "n4", 27.0, 90.0, "V03", "VM5"],
["2256910", "multifocal", "cyl > 4,00", "n5", 27.0, 90.0, "V04", "VM6"],
["2256560", "multifocal", "cyl > 4,00", "n6", 39.0, 130.0, "V04", "VM6"],
["2249229", "progressif", "spherique", "n1", 22.5, 75.0, "V03", "VM1"],
["2296803", "progressif", "spherique", "n2", 24.0, 80.0, "V03", "VM1"],
["2282913", "progressif", "spherique", "n3", 27.0, 90.0, "V04", "VM4"],
["2272748", "progressif", "spherique", "n4", 27.0, 90.0, "V04", "VM4"],
["2248030", "progressif", "spherique", "n5", 39.0, 130.0, "V04", "VM4"],
["2243511", "progressif", "spherique", "n6", 39.0, 130.0, "V04", "VM4"],
["2210635", "progressif", "spherique", "p1", 22.5, 75.0, "V03", "VM1"],
["2279934", "progressif", "spherique", "p2", 24.0, 80.0, "V03", "VM1"],
["2217376", "progressif", "spherique", "p3", 27.0, 90.0, "V04", "VM4"],
["2221917", "progressif", "spherique", "p4", 27.0, 90.0, "V04", "VM4"],
["2274730", "progressif", "spherique", "p5", 39.0, 130.0, "V04", "VM4"],
["2221604", "progressif", "spherique", "p6", 39.0, 130.0, "V04", "VM4"],
["2236362", "progressif", "cyl 0,25-4,00", "n1", 27.0, 90.0, "V03", "VM2"],
["2210061", "progressif", "cyl 0,25-4,00", "n2", 28.5, 95.0, "V03", "VM2"],
["2215957", "progressif", "cyl 0,25-4,00", "n3", 31.5, 105.0, "V03", "VM2"],
["2252177", "progressif", "cyl 0,25-4,00", "n4", 31.5, 105.0, "V03", "VM2"],
["2216359", "progressif", "cyl 0,25-4,00", "n5", 43.5, 145.0, "V04", "VM6"],
["2236066", "progressif", "cyl 0,25-4,00", "n6", 43.5, 145.0, "V04", "VM6"],
["2209342", "progressif", "cyl 0,25-4,00", "s1", 27.0, 90.0, "V03", "VM3"],
["2286118", "progressif", "cyl 0,25-4,00", "s2", 28.5, 95.0, "V03", "VM3"],
["2244203", "progressif", "cyl 0,25-4,00", "s3", 31.5, 105.0, "V03", "VM3"],
["2218950", "progressif", "cyl 0,25-4,00", "s4", 31.5, 105.0, "V03", "VM3"],
["2297910", "progressif", "cyl 0,25-4,00", "s5", 43.5, 145.0, "V04", "VM7"],
["2228411", "progressif", "cyl 0,25-4,00", "s6", 43.5, 145.0, "V04", "VM7"],
["2268273", "progressif", "cyl > 4,00", "n1", 34.5, 115.0, "V03", "VM5"],
["2229209", "progressif", "cyl > 4,00", "n2", 36.0, 120.0, "V03", "VM5"],
["2295175", "progressif", "cyl > 4,00", "n3", 39.0, 130.0, "V03", "VM5"],
["2224270", "progressif", "cyl > 4,00", "n4", 39.0, 130.0, "V03", "VM5"],
["2299196", "progressif", "cyl > 4,00", "n5", 51.0, 170.0, "V04", "VM6"],
["2234334", "progressif", "cyl > 4,00", "n6", 51.0, 170.0, "V04", "VM6"]];

// [code, designation, base, plv]
const AUTRES = [["2263927", "Verre neutre de classe A", 6.0, 20.0],
["2222124", "Monture adulte de classe A", 9.0, 30.0],
["2254242", "Monture enfant de classe A", 9.0, 30.0],
["2264223", "Supplément monture à coque, moins de 6 ans", 6.0, 20.0],
["2267641", "Supplément pour verres teintés", 1.5, 5.0],
["2226435", "Prestation d'adaptation, verres de classe A", 10.0, 10.0],
["2209738", "Prestation d'adaptation, verres de classe B", null, 10.0],
["2232252", "Prestation d'appairage niveau 1", 1.5, 5.0],
["2222503", "Prestation d'appairage niveau 2", 3.0, 10.0],
["2206987", "Prestation d'appairage niveau 3", 4.5, 15.0],
["2247905", "Prisme incorporé adulte, quelle que soit la puissance", 3.96, null],
["2287862", "Prisme incorporé enfant, quelle que soit la puissance", 16.01, null],
["2227920", "Prisme souple, moins de 6 ans", 22.41, null],
["2200795", "Système antiptosis adulte", 77.29, null],
["2293957", "Système antiptosis enfant", 77.29, null],
["2222408", "Filtre chromatique ou ultraviolet, moins de 18 ans", 9.15, null],
["2269025", "Filtre d'occlusion partielle, moins de 6 ans", 3.66, null],
["2278219", "Verres iséiconiques adulte, sur devis", null, null],
["2204066", "Verres iséiconiques enfant, sur devis", null, null]];


/* ===== devis.js ===== */
/* =====================================================================
   Moteur de calcul du devis normalise optique
   Les Lunettes de Pauline - version 1.0, 21 septembre 2026

   Entree  : la correction telle qu'elle est ecrite sur l'ordonnance
             (convention francaise, cylindre negatif) + le panier.
   Sortie  : les deux blocs du devis, lignes et totaux, prets a imprimer.

   Aucune dependance. Fonctionne dans le navigateur comme dans Node.
   ===================================================================== */

/* ---------------------------------------------------------------- outils */

const r2 = (x) => Math.round((x + Number.EPSILON) * 100) / 100;

/** Arrondi financier a 2 decimales, tolerant aux virgules et aux chaines. */
function n(v) {
  if (v === null || v === undefined || v === '') return null;
  const x = parseFloat(String(v).replace(',', '.'));
  return Number.isNaN(x) ? null : x;
}

/** Taux de remboursement de l'assurance maladie obligatoire. */
const TAUX_AMO = 0.6;

/**
 * Bornes de correction acceptées à la commande en ligne, telles qu'elles sont
 * écrites sur l'ordonnance (cylindre négatif dans 99 % des cas).
 * Une correction hors de ces bornes n'est pas refusée par le moteur : elle
 * remonte en alerte, pour que l'opticien tranche.
 */
const BORNES_SITE = { sphere: 4, cylindre: 2 };

/* ------------------------------------------------------- transposition */

/**
 * La LPP est ecrite en cylindre positif ; une ordonnance francaise ne l'est
 * presque jamais. On transpose avant toute lecture de la table.
 *   sph' = sph + cyl        cyl' = -cyl        axe' = axe +/- 90
 */
function transposer(sph, cyl, axe) {
  const s = n(sph) ?? 0;
  const c = n(cyl) ?? 0;
  const a = n(axe);
  if (c >= 0) return { sph: r2(s), cyl: r2(c), axe: a, transpose: false };
  let na = null;
  if (a !== null) na = a <= 90 ? a + 90 : a - 90;
  return { sph: r2(s + c), cyl: r2(-c), axe: na, transpose: true };
}

/* -------------------------------------------------------------- plages */

// Bornes communes a toutes les familles, en valeur absolue.
const BORNES = [2, 4, 6, 8, 12];

function rang(abs) {
  for (let i = 0; i < BORNES.length; i++) if (abs <= BORNES[i] + 1e-9) return i + 1;
  return 6;
}

const plageNegative = (s) => 'n' + rang(-s);   // s <= 0
const plagePositive = (s) => 'p' + rang(s);    // s > 0, verre spherique
const plageSomme    = (S) => 's' + rang(S);    // s > 0, verre sphero-cylindrique

/**
 * Determine la famille et la plage a partir d'une correction DEJA transposee.
 * Renvoie null si la nomenclature ne publie pas de ligne pour ce cas.
 */
function situer(sph, cyl) {
  const s = r2(n(sph) ?? 0);
  const c = r2(n(cyl) ?? 0);

  if (c === 0) {
    if (s === 0) return { famille: 'neutre', plage: null };
    return { famille: 'spherique', plage: s > 0 ? plagePositive(s) : plageNegative(s) };
  }

  const famille = c <= 4 ? 'cyl 0,25-4,00' : 'cyl > 4,00';

  if (s > 0) {
    if (famille === 'cyl > 4,00') {
      // La decision du 6 mars 2019 ne publie aucune ligne pour ce cas,
      // ni en classe A ni en classe B.
      return { famille, plage: null,
               absent: "Sphere positive avec un cylindre superieur a 4,00 : "
                     + "la nomenclature ne publie pas de ligne pour ce cas." };
    }
    return { famille, plage: plageSomme(r2(s + c)) };
  }
  return { famille, plage: plageNegative(s) };
}

/* ------------------------------------------------------- lecture table */

const NEUTRE = AUTRES.find((a) => /Verre neutre/i.test(a[1]));

/**
 * Trouve la ligne du bareme pour un oeil.
 * @param {string} type 'unifocal' | 'multifocal' | 'progressif'
 */
function lireBareme(type, sph, cyl, axe) {
  const t = transposer(sph, cyl, axe);
  t.brut = { sph: n(sph) ?? 0, cyl: n(cyl) ?? 0, axe: n(axe) };
  const pos = situer(t.sph, t.cyl);

  if (pos.famille === 'neutre') {
    return { ...t, ...pos, code: NEUTRE[0], base: NEUTRE[2], plv: NEUTRE[3],
             regroupementA: 'V01', regroupementB: null, trouve: true };
  }
  if (!pos.plage) return { ...t, ...pos, trouve: false };

  const l = VERRES.find((v) => v[1] === type && v[2] === pos.famille && v[3] === pos.plage);
  if (!l) return { ...t, ...pos, trouve: false,
                   absent: 'Aucune ligne pour ' + type + ' / ' + pos.famille + ' / ' + pos.plage };

  return { ...t, ...pos, trouve: true, code: l[0], base: l[4], plv: l[5],
           regroupementA: l[6], regroupementB: l[7] };
}

/* ------------------------------------------------------------- lignes */

function ligne(libelle, detail, code, prix, base) {
  const amo = base === null ? null : r2(base * TAUX_AMO);
  return {
    libelle, detail, code,
    prix: r2(prix),
    base: base === null ? null : r2(base),
    amo,
    amc: null,                       // inconnue de l'opticien a l'emission
    rac: amo === null ? r2(prix) : r2(prix - amo),
  };
}

function totaliser(lignes, racNul) {
  const somme = (k) => r2(lignes.reduce((a, l) => a + (l[k] ?? 0), 0));
  return {
    prix: somme('prix'), base: somme('base'), amo: somme('amo'),
    rac: racNul ? 0 : somme('rac'),
  };
}

/* ------------------------------------------------------------- devis */

/**
 * L'equipement de classe A cite par defaut dans le bloc obligatoire.
 * A remplacer par une reference reellement disponible : une monture de la gamme
 * Owlet Originals et un verre de classe A du fournisseur.
 */
const REFERENCE_CLASSE_A = {
  montureLibelle: 'Monture Owlet Originals OWII443, coloris Noir',
  monturePrix: null,      // par defaut le prix limite de vente, 30,00 EUR
  verreLibelle: 'Verres unifocaux de classe A, organiques 1,5 — CCSO UNIF 150 SARH',
  verrePrix: null,        // par defaut le prix limite de vente de la ligne LPP
};

const MONTURE_A = {
  adulte: AUTRES.find((a) => /Monture adulte de classe A/i.test(a[1])),
  enfant: AUTRES.find((a) => /Monture enfant de classe A/i.test(a[1])),
};
const ADAPTATION_A = AUTRES.find((a) => /adaptation, verres de classe A/i.test(a[1]));

const REGROUPEMENT_MONTURE = {
  'A-adulte': 'M01', 'A-enfant': 'M02',
  'B-adulte': 'M03', 'B-enfant': 'M04',
};

/**
 * Compose les deux blocs du devis.
 *
 * @param {object} p
 * @param {object} p.od            {sph, cyl, axe, add} tels qu'ecrits sur l'ordonnance
 * @param {object} p.og            idem
 * @param {string} p.type          'unifocal' | 'multifocal' | 'progressif'
 * @param {string} [p.age]         'adulte' (defaut) | 'enfant'
 * @param {object} [p.classeA]     l'equipement de reference cite dans le bloc obligatoire :
 *                                 {montureLibelle, monturePrix, verreLibelle, verrePrix}.
 *                                 C'est une offre alternative, independante du panier : le client
 *                                 achete ce qu'il veut, le bloc 100 % Sante cite toujours cette
 *                                 reference. Elle doit rester livrable sur demande.
 * @param {object} p.choix         l'equipement reellement choisi :
 *                                 {classe:'A'|'B', monture:{libelle,prix},
 *                                  verreOD:{libelle,prix}, verreOG:{libelle,prix}}
 * @param {boolean} [p.adaptation] facturer la prestation d'adaptation (defaut : true
 *                                 pour les multifocaux et progressifs)
 */
function composer(p) {
  const type = p.type;
  const age = p.age || 'adulte';
  const alertes = [];

  const od = lireBareme(type, p.od.sph, p.od.cyl, p.od.axe);
  const og = lireBareme(type, p.og.sph, p.og.cyl, p.og.axe);
  const bornes = p.bornes === null ? null : { ...BORNES_SITE, ...(p.bornes || {}) };

  [['droit', od], ['gauche', og]].forEach(([cote, o]) => {
    if (!o.trouve) alertes.push("Oeil " + cote + " : " + (o.absent || 'ligne introuvable'));
    if (!bornes) return;
    const b = o.brut;
    if (Math.abs(b.sph) > bornes.sphere + 1e-9) {
      alertes.push("Oeil " + cote + " : sphere " + b.sph.toFixed(2).replace('.', ',')
        + " hors des bornes de commande en ligne (" + bornes.sphere + ' dioptries).');
    }
    if (Math.abs(b.cyl) > bornes.cylindre + 1e-9) {
      alertes.push("Oeil " + cote + " : cylindre " + b.cyl.toFixed(2).replace('.', ',')
        + " hors des bornes de commande en ligne (" + bornes.cylindre + ' dioptries).');
    }
  });

  const adaptation = p.adaptation ?? (type !== 'unifocal');

  /* ---- bloc 1 : 100 % Sante ---- */
  const mA = MONTURE_A[age];
  const a = { ...REFERENCE_CLASSE_A, ...(p.classeA || {}) };
  const lignesA = [
    ligne(
      a.montureLibelle || mA[1],
      'Regroupement ' + REGROUPEMENT_MONTURE['A-' + age],
      mA[0],
      a.monturePrix ?? mA[3],
      mA[2],
    ),
  ];
  // Une paire classe A se monte dans le MEME verre aux deux yeux : l'indice
  // (donc la reference) est impose par l'oeil le plus fort, meme si l'autre
  // oeil est faiblement corrige. Le code LPP et le remboursement restent, eux,
  // propres a chaque oeil.
  const rangOeil = (o) => (o && o.trouve && o.plage) ? (parseInt(String(o.plage).slice(-1), 10) || 0) : 0;
  const oRef = rangOeil(og) > rangOeil(od) ? og : od;
  [['droit (OD)', od], ['gauche (OG)', og]].forEach(([cote, o]) => {
    if (!o.trouve) return;
    lignesA.push(ligne(
      (typeof a.verreLibelle === 'function'
        ? a.verreLibelle(oRef) + ' ' + cote
        : a.verreLibelle ? a.verreLibelle + ' ' + cote
        : 'Verre ' + type + ' ' + cote + ', classe A'),
      detailOeil(o) + ' - regroupement ' + o.regroupementA,
      codeClasseA(o),
      a.verrePrix ?? o.plv,
      o.base,
    ));
  });
  if (adaptation && ADAPTATION_A) {
    lignesA.push(ligne(ADAPTATION_A[1], null,
                       ADAPTATION_A[0], ADAPTATION_A[3], ADAPTATION_A[2]));
  }

  /* ---- bloc 2 : offre choisie ---- */
  const c = p.choix || {};
  const classeChoix = c.classe || 'B';
  const lignesB = [];
  if (c.monture) {
    lignesB.push(ligne(
      c.monture.libelle,
      'Classe ' + classeChoix + ' - regroupement '
        + REGROUPEMENT_MONTURE[classeChoix + '-' + age],
      REGROUPEMENT_MONTURE[classeChoix + '-' + age],
      c.monture.prix,
      classeChoix === 'A' ? mA[2] : 0.05,
    ));
  }
  [['droit (OD)', od, c.verreOD], ['gauche (OG)', og, c.verreOG]].forEach(([cote, o, v]) => {
    if (!v || !o.trouve) return;
    const enA = classeChoix === 'A';
    lignesB.push(ligne(
      v.libelle,
      detailOeil(o) + ' - regroupement ' + (enA ? o.regroupementA : o.regroupementB),
      enA ? o.code : o.regroupementB,
      v.prix,
      enA ? o.base : 0.05,
    ));
  });

  return {
    correction: { od, og, type, age },
    alertes,
    blocs: [
      { titre: 'Offre 100 % Santé', classe: 'A', racNul: true,
        lignes: lignesA, totaux: totaliser(lignesA, true) },
      { titre: 'Offre choisie', classe: classeChoix, racNul: classeChoix === 'A',
        lignes: lignesB, totaux: totaliser(lignesB, classeChoix === 'A') },
    ],
  };
}

/**
 * Le detail imprime la correction TELLE QU'ELLE EST ECRITE sur l'ordonnance :
 * c'est celle que le client reconnait. La transposition sert a trouver la
 * ligne du bareme, elle n'a pas a s'afficher a sa place.
 */
function detailOeil(o) {
  const f = (x, signe) => {
    const s = x.toFixed(2).replace('.', ',');
    return signe && x > 0 ? '+' + s : s;
  };
  const b = o.brut || o;
  let t = 'SPH ' + f(b.sph, true);
  if (b.cyl !== 0) t += ' / CYL ' + f(b.cyl, true);
  if (b.axe !== null && b.axe !== undefined) t += ' / AXE ' + b.axe + '°';
  return t;
}


/* ===== devis-pdf.js ===== */
/* =====================================================================
   Generateur du devis normalise optique - rendu PDF
   Les Lunettes de Pauline - version 1.0, 21 septembre 2026

   Prend la sortie de composer() (devis.js) et rend un PDF A4.
   Dependances : jsPDF + jspdf-autotable, chargees par le theme.
   Aucune dependance a une application tierce.
   ===================================================================== */

/* -------------------------------------------------------------- charte */

const C = {
  encre:  [26, 26, 26],
  gris:   [107, 107, 107],
  trait:  [200, 200, 200],
  fond:   [242, 242, 242],
  accent: [31, 78, 95],
  vert:   [29, 107, 66],
};

const MARGE = 15;          // mm
const BAS = 272;           // limite basse du contenu, mm
const LARGEUR = 210 - 2 * MARGE;

/* -------------------------------------------------------------- outils */

function eur(v) {
  if (v === null || v === undefined) return 'n.c.';
  return v.toFixed(2).replace('.', ',') + ' €';
}

/** Une chaine faite d'espaces n'est pas une ligne d'adresse. */
function nettoyer(v) {
  return (v === null || v === undefined) ? '' : String(v).trim();
}

function dateFr(d) {
  const x = d instanceof Date ? d : new Date(d);
  const p = (n) => String(n).padStart(2, '0');
  return p(x.getDate()) + '/' + p(x.getMonth() + 1) + '/' + x.getFullYear();
}

/** Date d'emission + 2 mois, la validite legale du devis. */
function dateLimite(emission) {
  const d = emission instanceof Date ? new Date(emission) : new Date(emission);
  d.setMonth(d.getMonth() + 2);
  return d;
}

/**
 * Numero unique. Prefixe + annee + suffixe non devinable.
 * A remplacer par un compteur cote serveur des qu'il y en aura un.
 */
function numeroDevis(prefixe) {
  var p = prefixe || 'DEV';
  var annee = new Date().getFullYear();
  var alpha = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';   // sans I, O, 0, 1
  var buf = new Uint8Array(8);
  var c = (typeof globalThis !== 'undefined' && globalThis.crypto) ? globalThis.crypto : null;
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(buf);
  } else {
    for (var i = 0; i < buf.length; i++) {
      buf[i] = Math.floor(Math.random() * 256);
    }
  }
  var s = '';
  for (var k = 0; k < buf.length; k++) {
    s += alpha.charAt(buf[k] % alpha.length);
  }
  return p + '-' + annee + '-' + s;
}

/* ---------------------------------------------------------------- rendu */

/**
 * @param {object} devis      sortie de composer()
 * @param {object} ctx
 * @param {object} ctx.opticien   {nom, adresse, cp, ville, tel, email, siret, tva, finess, praticien, rpps}
 * @param {object} ctx.client     {nom, adresse, cp, ville, email}
 * @param {object} ctx.ordonnance {date, prescripteur}
 * @param {object} [ctx.prescription] {od:{sph,cyl,axe,add}, og:{...}}  telle qu'ecrite
 * @param {string} [ctx.numero]
 * @param {Date}   [ctx.emission]
 * @param {string} [ctx.exemplaire] 'client' (defaut) | 'opticien'
 * @param {string} [ctx.cgv]      texte des conditions generales, page 2
 * @param {object} deps           {jsPDF, autoTable}
 * @returns {{doc:object, numero:string, emission:Date, limite:Date}}
 */
function rendre(devis, ctx, deps) {
  const { jsPDF, autoTable } = deps;
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });

  // jspdf-autotable s'utilise soit comme fonction (paquet ES), soit comme
  // greffon attache au document (bundle UMD charge dans un navigateur).
  function table(options) {
    if (typeof autoTable === 'function') return autoTable(doc, options);
    if (typeof doc.autoTable === 'function') return doc.autoTable(options);
    throw new Error('jspdf-autotable est introuvable');
  }

  const numero = ctx.numero || numeroDevis();
  const emission = ctx.emission || new Date();
  const limite = dateLimite(emission);
  const o = ctx.opticien, cl = ctx.client;

  let y = 14;

  /** Passe a la page suivante si le bloc de hauteur h ne tient plus. */
  const place = (h) => { if (y + h > BAS) { doc.addPage(); y = 18; } };

  /* --- en-tete --- */
  doc.setFont('helvetica', 'bold').setFontSize(16).setTextColor(...C.accent);
  doc.text('DEVIS NORMALISÉ', MARGE, y);
  doc.setFont('helvetica', 'normal').setFontSize(9).setTextColor(...C.gris);
  doc.text("Équipement d'optique médicale", MARGE, y + 5.5);

  const droite = 210 - MARGE;
  doc.setFont('helvetica', 'bold').setFontSize(9).setTextColor(...C.encre);
  doc.text('Exemplaire ' + (ctx.exemplaire || 'client'), droite, y - 1, { align: 'right' });
  doc.setFont('helvetica', 'normal').setFontSize(8.5);
  doc.text('Devis n° ' + numero, droite, y + 3.5, { align: 'right' });
  doc.text('Émis le ' + dateFr(emission), droite, y + 7.5, { align: 'right' });
  doc.setFont('helvetica', 'bold').setTextColor(...C.vert);
  doc.text("Valable jusqu'au " + dateFr(limite), droite, y + 11.5, { align: 'right' });

  y += 14;
  doc.setDrawColor(...C.accent).setLineWidth(0.5).line(MARGE, y, droite, y);
  y += 5;

  /* --- identites --- */
  const colL = LARGEUR / 2;
  const blocOpticien = [
    o.nom,
    o.raisonSociale ? o.raisonSociale + ', opticien-lunetier' : null,
    o.adresse,
    (o.cp || '') + ' ' + (o.ville || ''),
    [o.tel, o.email].filter(Boolean).join(' – '),
    'SIRET ' + (o.siret || '—') + (o.tva ? ' – TVA ' + o.tva : ''),
    'N° FINESS ' + (o.finess || '—'),
  ].filter(Boolean);
  const blocClient = [
    cl.nom, cl.naissance ? 'Né(e) le ' + dateFr(cl.naissance) : null, cl.adresse, (cl.cp || '') + ' ' + (cl.ville || ''), cl.email,
  ].map(nettoyer).filter(Boolean);

  // Sans identification du client, on n'imprime pas un cadre vide :
  // le bloc opticien prend toute la largeur.
  const avecClient = blocClient.length > 0;
  const largeurOpticien = avecClient ? colL : LARGEUR;

  const hBloc = 8 + 3.9 * Math.max(blocOpticien.length, blocClient.length);
  doc.setDrawColor(...C.trait).setLineWidth(0.2);
  doc.rect(MARGE, y, largeurOpticien, hBloc);
  if (avecClient) doc.rect(MARGE + colL, y, colL, hBloc);

  const ecrireBloc = (titre, lignes, x) => {
    doc.setFont('helvetica', 'bold').setFontSize(7.5).setTextColor(...C.gris);
    doc.text(titre, x + 3, y + 4.5);
    doc.setFont('helvetica', 'normal').setFontSize(8.5).setTextColor(...C.encre);
    lignes.forEach((l, i) => {
      if (i === 0) doc.setFont('helvetica', 'bold');
      doc.text(String(l), x + 3, y + 9 + i * 3.9);
      if (i === 0) doc.setFont('helvetica', 'normal');
    });
  };
  ecrireBloc("L'OPTICIEN", blocOpticien, MARGE);
  if (avecClient) ecrireBloc('LE CLIENT', blocClient, MARGE + colL);
  y += hBloc + 6;

  /* --- prescription --- */
  doc.setFont('helvetica', 'bold').setFontSize(7.5).setTextColor(...C.gris);
  doc.text('PRESCRIPTION MÉDICALE', MARGE, y);
  y += 4.5;
  doc.setFont('helvetica', 'normal').setFontSize(8.5).setTextColor(...C.encre);
  const ord = ctx.ordonnance || {};
  // On n'imprime cette ligne que si on a quelque chose a y mettre :
  // un « Ordonnance du — » ne renseigne personne.
  const ordParts = [];
  if (ord.date) ordParts.push('Ordonnance du ' + dateFr(ord.date));
  if (ord.prescripteur) ordParts.push(ord.prescripteur);
  if (ordParts.length) {
    doc.text(ordParts.join(' – '), MARGE, y);
    y += 4;
  } else {
    y -= 1;
  }

  const p = ctx.prescription || {};
  const cell = (v, suffixe) => (v === null || v === undefined || v === '')
    ? '—'
    : (Number(v) > 0 ? '+' : '') + Number(v).toFixed(2).replace('.', ',') + (suffixe || '');
  table({
    startY: y,
    margin: { left: MARGE + 25, right: MARGE },
    head: [['', 'Sphère', 'Cylindre', 'Axe', 'Addition']],
    body: [
      ['Œil droit (OD)',  cell(p.od?.sph), cell(p.od?.cyl),
       p.od?.axe != null ? p.od.axe + '°' : '—', cell(p.od?.add)],
      ['Œil gauche (OG)', cell(p.og?.sph), cell(p.og?.cyl),
       p.og?.axe != null ? p.og.axe + '°' : '—', cell(p.og?.add)],
    ],
    theme: 'plain',
    styles: { font: 'helvetica', fontSize: 8, cellPadding: 1.2, textColor: C.encre },
    headStyles: { fontStyle: 'bold', fillColor: C.fond, fontSize: 7.5 },
    columnStyles: { 0: { cellWidth: 32 } },
  });
  y = doc.lastAutoTable.finalY + 6;

  /* --- blocs de l'equipement --- */
  devis.blocs.forEach((bloc) => {
    place(34);
    const couleur = bloc.classe === 'A' && bloc.racNul ? C.vert : C.accent;
    const titre = bloc.titre + (bloc.racNul ? ' – reste à charge 0 €' : '')
                             + (bloc.racNul ? '' : ' – classe ' + bloc.classe);

    doc.setFillColor(...couleur).rect(MARGE, y, LARGEUR, 6.4, 'F');
    doc.setFont('helvetica', 'bold').setFontSize(10).setTextColor(255, 255, 255);
    doc.text(titre, MARGE + 3, y + 4.4);
    y += 9;

    table({
      startY: y,
      margin: { left: MARGE, right: MARGE },
      head: [['Désignation', 'Code LPP', 'Prix de\nvente TTC',
              'Base de\nremb.', 'AMO', 'AMC', 'Reste à\ncharge']],
      body: bloc.lignes.map((l) => [
        l.detail ? l.libelle + '\n' + l.detail : l.libelle,
        l.code, eur(l.prix), eur(l.base), eur(l.amo),
        l.amc === null ? 'n.c.' : eur(l.amc),
        eur(bloc.racNul ? 0 : l.rac),
      ]),
      foot: [['Total', '', eur(bloc.totaux.prix), eur(bloc.totaux.base),
              eur(bloc.totaux.amo), '', eur(bloc.totaux.rac)]],
      theme: 'plain',
      styles: { font: 'helvetica', fontSize: 7.5, cellPadding: 1.15,
                textColor: C.encre, valign: 'top' },
      headStyles: { fontStyle: 'bold', fontSize: 7.2, fillColor: C.fond,
                    lineWidth: { bottom: 0.4 }, lineColor: couleur },
      footStyles: { fontStyle: 'bold', fontSize: 7.5, fillColor: false,
                    lineWidth: { top: 0.4 }, lineColor: couleur, textColor: C.encre },
      columnStyles: {
        0: { cellWidth: 66 }, 1: { cellWidth: 20 },
        2: { cellWidth: 22, halign: 'right' }, 3: { cellWidth: 22, halign: 'right' },
        4: { cellWidth: 15, halign: 'right' }, 5: { cellWidth: 15, halign: 'right' },
        6: { cellWidth: 20, halign: 'right' },
      },
      didParseCell: (d) => {
        if (d.section === 'body' && d.column.index === 0 && d.cell.raw.includes('\n')) {
          d.cell.styles.fontSize = 7.5;
        }
      },
    });
    y = doc.lastAutoTable.finalY + 2.5;

    doc.setFont('helvetica', 'normal').setFontSize(7).setTextColor(...C.gris);
    const note = bloc.racNul
      ? "Cette offre est présentée en premier, comme l'impose l'arrêté du 28 avril 2017 "
        + "modifié. Le reste à charge est nul dans le cadre d'un contrat responsable. "
        + 'AMO : assurance maladie obligatoire. AMC : complémentaire santé ; n.c. : non communiqué. '
        + 'Les corrections sont reproduites telles qu\'elles figurent sur l\'ordonnance ; les codes et les '
        + 'bases de remboursement sont établis après transposition en cylindre positif, comme l\'impose la nomenclature.'
      : "Le reste à charge indiqué est calculé avant intervention de votre complémentaire "
        + "santé, que l'opticien ne connaît pas au moment d'émettre le devis.";
    doc.text(doc.splitTextToSize(note, LARGEUR), MARGE, y + 2.5);
    y += 2.5 + 3.2 * doc.splitTextToSize(note, LARGEUR).length + 4.5;
  });

  /* --- alertes eventuelles --- */
  if (devis.alertes && devis.alertes.length) {
    doc.setFont('helvetica', 'bold').setFontSize(8).setTextColor(180, 60, 20);
    doc.text('À vérifier par l’opticien', MARGE, y);
    doc.setFont('helvetica', 'normal').setFontSize(7.5);
    devis.alertes.forEach((a, i) => doc.text('• ' + a, MARGE, y + 4 + i * 3.6));
    y += 6 + devis.alertes.length * 3.6;
  }

  /* --- garanties, accord et mentions : un groupe insecable --- */
  doc.setFontSize(8.5);
  const typeVerre = (devis.correction && devis.correction.type) || 'unifocal';
  const garTexte = 'Monture de classe A : garantie 2 ans contre tout défaut. '
            + (typeVerre === 'unifocal'
                ? ''
                : 'Verres multifocaux ou progressifs de classe A : période d\'adaptation de 3 mois. ')
            + 'Adaptation de la prescription par l\'opticien-lunetier dans les conditions prévues '
            + 'par la réglementation. Droit de rétractation de 14 jours à distance, dans les '
            + 'conditions prévues par nos conditions générales.';
  const garLignes = doc.splitTextToSize(garTexte, LARGEUR);
  place(9 + garLignes.length * 3.9 + 4.5 + 24 + 4.5 + 10);

  doc.setFont('helvetica', 'bold').setFontSize(7.5).setTextColor(...C.gris);
  doc.text('GARANTIES ET PRESTATIONS', MARGE, y);
  doc.setFont('helvetica', 'normal').setFontSize(8.5).setTextColor(...C.encre);
  const garL = garLignes;
  doc.text(garL, MARGE, y + 5);
  y += 5 + garL.length * 3.9 + 4.5;

  /* --- accord et signature --- */
  const hAcc = 24;
  doc.setDrawColor(...C.trait).setLineWidth(0.2);
  doc.rect(MARGE, y, colL, hAcc);
  doc.rect(MARGE + colL, y, colL, hAcc);

  doc.setFont('helvetica', 'bold').setFontSize(8.5).setTextColor(...C.encre);
  doc.text('Bon pour accord', MARGE + 3, y + 5);
  doc.setFont('helvetica', 'normal').setFontSize(8);
  doc.text(doc.splitTextToSize(
    "Mention « lu et approuvé, bon pour accord » et date, écrites par le client :",
    colL - 6), MARGE + 3, y + 10);
  doc.setDrawColor(...C.trait).line(MARGE + 3, y + 21, MARGE + colL - 3, y + 21);

  doc.setFont('helvetica', 'bold').setFontSize(8.5);
  doc.text((o.titrePraticien ? 'L’' + o.titrePraticien.split(' ')[0] : "L'opticien-lunetier"), MARGE + colL + 3, y + 5);
  doc.setFont('helvetica', 'normal').setFontSize(8);
    doc.text((o.praticien || '—') + (o.titrePraticien ? ', ' + o.titrePraticien : ''), MARGE + colL + 3, y + 10);
  doc.text('N° RPPS ' + (o.rpps || '—'), MARGE + colL + 3, y + 14);
  doc.setDrawColor(...C.trait).line(MARGE + colL + 3, y + 21, droite - 3, y + 21);
  y += hAcc + 4.5;

  /* --- mentions --- */
  doc.setFont('helvetica', 'normal').setFontSize(7).setTextColor(...C.gris);
  place(12);
  const men = 'Devis gratuit et sans engagement, valable 2 mois à compter de son émission. '
            + "Conservé par l'opticien pendant 1 an. Établi en application de l'article L.165-9 "
            + "du code de la sécurité sociale et de l'arrêté du 28 avril 2017 modifié.";
  const menL = doc.splitTextToSize(men, LARGEUR);
  doc.text(menL, MARGE, y);
  y += menL.length * 3.2;

  /* --- conditions generales --- */
  if (ctx.cgv) {
    y += 8;
    place(24);
    doc.setFont('helvetica', 'bold').setFontSize(10).setTextColor(...C.accent);
    doc.text('Conditions générales de vente', MARGE, y);
    y += 6;
    doc.setFont('helvetica', 'normal').setFontSize(7).setTextColor(...C.encre);
    for (const l of doc.splitTextToSize(ctx.cgv, LARGEUR)) {
      place(4);
      doc.text(l, MARGE, y);
      y += 3.1;
    }
  }

  /* --- pieds de page --- */
  const n = doc.getNumberOfPages();
  for (let i = 1; i <= n; i++) {
    doc.setPage(i);
    doc.setFont('helvetica', 'normal').setFontSize(7).setTextColor(...C.gris);
    doc.text((o.raisonSociale ? o.raisonSociale + ' – ' : '') + o.nom + ' – SIRET ' + (o.siret || '—')
             + ' – N° FINESS ' + (o.finess || '—'), MARGE, 285);
    doc.text(i + ' / ' + n, droite, 285, { align: 'right' });
  }

  return { doc, numero, emission, limite };
}

/** Raccourci navigateur : rend et telecharge. */
function telecharger(devis, ctx, deps) {
  const r = rendre(devis, ctx, deps);
  r.doc.save(r.numero + '.pdf');
  return r;
}


/* ===== opticien.js ===== */
/* =====================================================================
   Identite de l'opticien et references de l'offre 100 % Sante.
   Un seul fichier a tenir a jour : c'est le seul endroit du projet qui
   contient des donnees propres a la boutique.
   ===================================================================== */

const OPTICIEN = {
  nom:           'Les Lunettes de Pauline',
  raisonSociale: 'SAS MPM',
  adresse:       '83 place Andrée-Marie Perrin',
  cp:            '69290',
  ville:         'Craponne',
  tel:           '04 37 22 02 47',
  email:         'web@leslunettesdepauline.com',
  siret:         '832 148 910 00017',
  tva:           'FR34 832 148 910',
  finess:        '692681067',
  praticien:     'Pauline Moiret',
  titrePraticien: 'opticienne-lunetière diplômée',
  rpps:          '10008758236',
};

/* ---------------------------------------------------------------------
   Le verre de classe A cite dans le bloc obligatoire.

   La reference du fournisseur change selon la correction : l'arrete du
   3 decembre 2018 impose un indice de refraction minimal fonction du
   niveau de correction. Sur les bornes du site : 1,5 / 1,59 / 1,67.
   Les references CCSO sont relevees sur IDM Optic.
   --------------------------------------------------------------------- */

// Codes LPP individuels Ophtalmic Cie (releves sur la base ameli via IDM Optic),
// par famille et par plage. Le code affiche depend de la correction de chaque oeil.
// Seul manquant : cyl 0,25-4,00 s6 (somme > 12), cas ultra-rare.
const LPP_OPHTALMIC = {
  'spherique': {
    n1: '7272285', n2: '7272351', n3: '7272948', n4: '7272865', n5: '7272730', n6: '7272368',
    p1: '7272664', p2: '7272500', p3: '7272492', p4: '7272300', p5: '7272210', p6: '7272931'
  },
  'cyl 0,25-4,00': {
    n1: '7272629', n2: '7272658', n3: '7272799', n4: '7272470', n5: '7272180', n6: '7272760',
    s1: '7272782', s2: '7272374', s3: '7272316', s4: '7286755', s5: '7272641'
  },
  'cyl > 4,00': {
    n1: '7272345', n2: '7272150', n3: '7272262', n4: '7272517', n5: '7272109', n6: '7272546'
  }
};

/** Code LPP classe A a afficher pour un oeil : code individuel Ophtalmic si connu,
 *  sinon on retombe sur le code generique de la nomenclature (o.code). */
function codeClasseA(o) {
  var fam = o && o.famille, pl = o && o.plage;
  var t = fam && LPP_OPHTALMIC[fam];
  return (t && pl && t[pl]) || (o && o.code) || '';
}

function refClasseA(o) {
  // Indice mini + reference fournisseur (releve IDM Optic) selon la puissance,
  // arrete du 3 decembre 2018 :  |P| <= 2 D -> 1,5 (CCSO 150) ;
  //   2 a 4 D -> 1,59 (CCSO 159) ;  4 a 8 D -> 1,67 (CCSO 167 AS) ;
  //   8 a 12 D -> 1,74 (CCSO 174 AS) ;  au-dela de 12 D -> indice libre.
  // Rang de plage deja calcule par lireBareme() (dernier caractere de o.plage :
  // 'n3' -> rang 3), qui porte la puissance transposee, donc le meridien le plus fort.
  var rang = parseInt(String((o && o.plage) || '1').slice(-1), 10) || 1;
  if (rang <= 1) return { indice: '1,5',  ref: 'CCSO UNIF 150 SARH' };
  if (rang === 2) return { indice: '1,59', ref: 'CCSO UNIF 159 SARH' };
  if (rang <= 4) return { indice: '1,67', ref: 'CCSO UNIF 167 AS SARH' };
  if (rang === 5) return { indice: '1,74', ref: 'CCSO UNIF 174 AS SARH' };
  return { indice: '1,74', ref: null };
}

/** Reference du verre classe A, adaptee a la correction de chaque oeil. */
const VERRE_CLASSE_A = function (o) {
  var r = refClasseA(o);
  return 'Verres unifocaux de classe A, organiques ' + r.indice
       + (r.ref ? ' — ' + r.ref : '');
};

const MONTURE_CLASSE_A = 'Monture Owlet Originals OWII443, coloris Noir';

/** Bloc pret a passer a composer({ classeA: REFERENCE }). */
const REFERENCE = {
  montureLibelle: MONTURE_CLASSE_A,
  verreLibelle:   VERRE_CLASSE_A,
};


  global.DevisNormalise = {
    composer, lireBareme, situer, transposer,
    rendre, telecharger, numeroDevis, dateLimite, eur,
    OPTICIEN, REFERENCE, VERRE_CLASSE_A, MONTURE_CLASSE_A,
    BORNES_SITE, REFERENCE_CLASSE_A, TAUX_AMO,
    VERRES, AUTRES,
  };
})(typeof window !== 'undefined' ? window : globalThis);
